import type React from 'react';
import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import { PageLoading } from '@/app/components/page-loading.tsx';

const LazyAdmin = lazy(() => import('./Admin'));

const Admin = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode }) => {
  return (
    <Suspense fallback={<PageLoading />}>
      <LazyAdmin {...props} />
    </Suspense>
  );
};

export const adminRoute = {
  path: '/admin',
  element: <Admin />,
} as RouteObject;
export default Admin;
